module.exports = __webpack_public_path__ + "static/media/ic_pt-br.50283bcc.svg";